import { ReverseAddressService } from "../../../utility/tdtService/ReverseGeocoding/ReverseAddressService";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs";
import { SystemConfig } from "../../../config/SystemConfig";

/*
 * @Author: your name
 * @Date: 2019-11-11 19:57:52
 * @LastEditTime: 2019-11-12 11:29:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\model\ReverseAddress.js
 */
export class ReverseAddress
{   
    constructor()
    {   

    }

    static getAddress(lon,lat,succeedCallback, errorCallback)
    {   
        let addressService=new ReverseAddressService();
        addressService.lat=lat;
        addressService.lon=lon;
        addressService.token=SystemConfig.token;
        addressService.tdtURL=ServiceUrlConfig.tdt_service_reverse_address_url;
        
        addressService.ReverseAddress(succeedCallback,errorCallback);
    }



}